// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M13 2L13 16.5H11L11 2L13 2ZM11 19H13.0039V21.0039H11V19Z"}}]};

const ErrorIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'error',
    ref,
    icon: element,
  },
));

ErrorIcon.displayName = 'ErrorIcon';

export default ErrorIcon;
